import { isObject } from '../../is-object';

export interface ErrorAnswer {
    description?: string;
    error?: string;
    message?: string;
}

export function isErrorAnswer(error: unknown): error is ErrorAnswer {
    return (
        isObject(error) &&
        (('description' in error && typeof error.description === 'string') ||
            ('error' in error && typeof error.error === 'string') ||
            ('message' in error && typeof error.message === 'string'))
    );
}
